import dayjs from "dayjs";

export const DELIVERY_WINDOW_MINS = 5;

export interface OrderTimeParams {
  pickupTime?: string | null;
  scheduledFor?: string | null;
  orderPlacedAt?: string | null;
  serviceMode?: string;
}

export interface GaugeInfo {
  minsLeft: number;
  progress: number;
}

function resolveAnchor({ pickupTime, scheduledFor, orderPlacedAt, serviceMode }: OrderTimeParams): dayjs.Dayjs {
  if (pickupTime) return dayjs(pickupTime);
  if (scheduledFor) return dayjs(scheduledFor);
  const base = orderPlacedAt ? dayjs(orderPlacedAt) : dayjs();
  return base.add(serviceMode === "delivery" ? 30 : 25, "minute");
}

export function getDeliveryWindow(params: OrderTimeParams): { windowStart: string; windowEnd: string } {
  const anchor = resolveAnchor(params);
  return {
    windowStart: anchor.subtract(DELIVERY_WINDOW_MINS, "minute").format("HH:mm"),
    windowEnd: anchor.add(DELIVERY_WINDOW_MINS, "minute").format("HH:mm"),
  };
}

export function getGaugeInfo(params: OrderTimeParams): GaugeInfo {
  const now = dayjs();
  const base = params.orderPlacedAt ? dayjs(params.orderPlacedAt) : now;
  const anchor = resolveAnchor(params);
  const total = anchor.diff(base, "second");
  const elapsed = now.diff(base, "second");
  const progress = total > 0 ? Math.min(1, Math.max(0, elapsed / total)) : 0;
  const minsLeft = Math.ceil(Math.max(0, anchor.diff(now, "minute", true)));
  return { minsLeft, progress };
}

export function formatTimeLeft(minsLeft: number): { value: string; unit: string } {
  if (minsLeft >= 60) return { value: String(Math.round(minsLeft / 60)), unit: "hr" };
  return { value: String(minsLeft), unit: "min" };
}
